import { LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { LifecycleHooks } from './consts';
import { runGlobalHooks } from './methods';
export const Input = property;
export const Reactive = state;
export class TiniComponent extends LitElement {
    constructor() {
        super(...arguments);
        this.initialized = false;
    }
    connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        // subscribe store
        this.subscribeStore();
        // run hooks
        runGlobalHooks(LifecycleHooks.OnCreate, this);
        (_b = (_a = this).onCreate) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        // run hooks
        runGlobalHooks(LifecycleHooks.OnDestroy, this);
        (_b = (_a = this).onDestroy) === null || _b === void 0 ? void 0 : _b.call(_a);
        // unsubscribe store
        this.unsubscribeStore();
    }
    willUpdate(changedProperties) {
        var _a, _b;
        runGlobalHooks(LifecycleHooks.OnChanges, this);
        (_b = (_a = this).onChanges) === null || _b === void 0 ? void 0 : _b.call(_a, changedProperties);
    }
    firstUpdated(changedProperties) {
        var _a, _b;
        // process children rendering
        const root = this.shadowRoot;
        const children = root.querySelectorAll('[await]');
        if (!children.length) {
            this.childrenRender();
            this.childrenReady();
        }
        else {
            const childrenList = Array.from(children);
            this.getChildrenLifecyclePromise(childrenList, 'childrenRender').then(() => this.childrenRender());
            this.getChildrenLifecyclePromise(childrenList, 'childrenReady').then(() => this.childrenReady());
        }
        // run hooks
        runGlobalHooks(LifecycleHooks.OnFirstRender, this);
        (_b = (_a = this).onFirstRender) === null || _b === void 0 ? void 0 : _b.call(_a, changedProperties);
    }
    updated(changedProperties) {
        var _a, _b;
        runGlobalHooks(LifecycleHooks.OnRenders, this);
        (_b = (_a = this).onRenders) === null || _b === void 0 ? void 0 : _b.call(_a, changedProperties);
    }
    childrenRender() {
        var _a, _b;
        runGlobalHooks(LifecycleHooks.OnChildrenRender, this);
        (_b = (_a = this).onChildrenRender) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    childrenReady() {
        var _a, _b;
        runGlobalHooks(LifecycleHooks.OnChildrenReady, this);
        (_b = (_a = this).onChildrenReady) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    async scheduleUpdate() {
        var _a;
        // A: subsequent updates
        if (this.initialized) {
            super.scheduleUpdate();
        }
        // B: no dependencies
        else if (!((_a = this.pendingDependencies) === null || _a === void 0 ? void 0 : _a.length)) {
            this.digestDI();
        }
        // C: has dependencies
        else {
            for (let i = 0; i < this.pendingDependencies.length; i++) {
                await this.pendingDependencies[i]();
            }
            this.digestDI();
        }
    }
    digestDI() {
        var _a, _b;
        this.initialized = true;
        this.pendingDependencies = [];
        // run hooks
        runGlobalHooks(LifecycleHooks.OnInit, this);
        const onInit = (_b = (_a = this).onInit) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!(onInit === null || onInit === void 0 ? void 0 : onInit.then)) {
            this.digestOnInit();
        }
        else {
            onInit.then(() => this.digestOnInit());
        }
        // continue
        super.scheduleUpdate();
    }
    digestOnInit() {
        setTimeout(() => {
            var _a, _b;
            runGlobalHooks(LifecycleHooks.OnReady, this);
            (_b = (_a = this).onReady) === null || _b === void 0 ? void 0 : _b.call(_a);
        }, 0);
    }
    getChildrenLifecyclePromise(children, hookName) {
        const promises = children
            .filter(item => !!item[hookName])
            .map(item => {
            let resolve = () => { };
            const original = item[hookName];
            item[hookName] = () => {
                original.call(item);
                resolve();
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise(r => (resolve = r));
        });
        return Promise.all(promises);
    }
    subscribeStore() {
        var _a, _b;
        var _c;
        if (!((_b = (_a = this.storeManager) === null || _a === void 0 ? void 0 : _a.pending) === null || _b === void 0 ? void 0 : _b.length))
            return;
        const unsubscribes = ((_c = this.storeManager).unsubscribes || (_c.unsubscribes = []));
        this.storeManager.pending.forEach(([store, stateKey, propertyName, reactive]) => {
            const unsubscribe = store.subscribe(stateKey, (value) => {
                this[propertyName] = value;
                if (reactive)
                    this.requestUpdate();
            });
            unsubscribes.push(unsubscribe);
        });
    }
    unsubscribeStore() {
        var _a, _b;
        if (!((_b = (_a = this.storeManager) === null || _a === void 0 ? void 0 : _a.unsubscribes) === null || _b === void 0 ? void 0 : _b.length))
            return;
        this.storeManager.unsubscribes.forEach(unsubscribe => unsubscribe());
        this.storeManager.unsubscribes = [];
    }
}
TiniComponent.defaultTagName = 'tini-component';
TiniComponent.componentName = 'unnamed';
TiniComponent.componentType = 'component';
//# sourceMappingURL=main.js.map